var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.591 7.723c2.146 1.25 2.16 4.211.027 5.479L5.172 20.598C2.92 21.936 0 20.394 0 17.866V3.225C0 .71 2.892-.834 5.146.478L17.59 7.723z",
    fill: "url(#logo-small_svg__paint0_linear_2539_12230)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-small_svg__paint0_linear_2539_12230",
    x1: -16.866,
    y1: 11.786,
    x2: -8.926,
    y2: 28.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })))));
}

export default SvgLogoSmall;